'use strict';

export default [
  {
    name: `Work`,
    link: `work`,
  },
  {
    name: `Life`,
    link: `life`,
  },
];



// WEBPACK FOOTER //
// ./client/models/global/menu.js